<template>
  <div
    class="fixed z-50 w-full h-16 max-w-lg -translate-x-1/2 bg-[#222222] border-2 border-[#d20a0a] rounded-full bottom-1 left-1/2"
  >
    <div class="grid h-full max-w-lg grid-cols-5 mx-auto">
      <!-- coleção de cursos -->
      <router-link
        :to="{ name: 'coll' }"
        data-tooltip-target="tooltip-home"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 rounded-s-full hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
          menuActive == 'colecao'
            ? 'bg-[#161616] font-semibold text-[#d20a0a]'
            : 'text-white',
        ]"
      >
        <PhMonitorPlay class="w-7 h-7" />
        <span class="sr-only">coleção</span>
      </router-link>
      <div
        id="tooltip-home"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        coleção
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <!-- progresso -->
      <router-link
        :to="{ name: 'prog' }"
        data-tooltip-target="tooltip-wallet"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
          menuActive == 'progresso'
            ? 'bg-[#161616] font-semibold text-[#d20a0a]'
            : 'text-white',
        ]"
      >
        <PhChartLineUp class="w-7 h-7" />
        <span class="sr-only">progresso</span>
      </router-link>
      <div
        id="tooltip-wallet"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip"
      >
        progresso
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <!-- home - centro -->
      <div class="flex items-center justify-center">
        <router-link
          :to="{ name: 'home' }"
          data-tooltip-target="tooltip-new"
          type="button"
          class="inline-flex items-center justify-center w-12 h-12 font-medium rounded-full group ring-2"
          :class="[
            menuActive == 'inicio'
              ? 'font-semibold bg-white ring-[#d20a0a] text-[#d20a0a]'
              : 'bg-[#d20a0a] ring-white text-white',
          ]"
        >
          <!-- <PhVideo class="w-7 h-7" /> -->
          <PhHouse class="w-8 h-8 mb-1" />
          <span class="sr-only">inicio</span>
        </router-link>
      </div>
      <div
        id="tooltip-new"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        inicio
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <!-- certificados -->
      <router-link
        :to="{ name: 'cert' }"
        data-tooltip-target="tooltip-settings"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
          menuActive == 'certificados'
            ? 'bg-[#161616] font-semibold text-[#d20a0a]'
            : 'text-white',
        ]"
      >
        <PhCertificate class="w-7 h-7" />
        <span class="sr-only">certificados</span>
      </router-link>
      <div
        id="tooltip-settings"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        certificados
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>

      <!-- perfil -->
      <router-link
        :to="{ name: 'prof' }"
        data-tooltip-target="tooltip-profile"
        type="button"
        class="inline-flex flex-col items-center justify-center px-5 rounded-e-full hover:bg-[#161616] hover:text-[#d20a0a] group"
        :class="[
          menuActive == 'perfil'
            ? 'bg-[#161616] font-semibold text-[#d20a0a]'
            : 'text-white',
        ]"
      >
        <PhUserCircle class="w-7 h-7" />
        <span class="sr-only">Perfil</span>
      </router-link>
      <div
        id="tooltip-profile"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium transition-opacity duration-300 rounded-lg shadow-xs opacity-0 tooltip"
      >
        Perfil
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import {
  PhCalendar,
  PhCertificate,
  PhChartLineUp,
  PhCurrencyCircleDollar,
  PhHouse,
  PhHouseLine,
  PhMonitorPlay,
  PhNewspaper,
  PhUserCircle,
  PhVideo
} from '@phosphor-icons/vue'
import { computed } from 'vue'

const menuActive = computed(() => dataShared.getters.getMenuActive)
</script>
